import { lightenOrDarkenColor } from 'cio/utils/color-functions';
import {
  GRAY_100,
  GRAY_200,
  GRAY_300,
  GRAY_400,
  GRAY_500,
  GRAY_700,
  GRAY_900,
  GREEN_100,
  GREEN_900,
  RED_100,
  RED_900,
  WHITE,
} from 'cio/utils/colors';

export type SyntaxHighlightThemePalette = {
  bgPrimary: string;
  bgSecondary: string;
  bgIndents: string;
  bgHighlight: string;

  border: string;

  text01: string;
  text02: string;
  text03: string;

  purple: string;
  teal: string;
  yellow: string;
  blue: string;
  raspberry: string;
  clementine: string;

  greenBg: string;
  greenFg: string;

  redBg: string;
  redFg: string;
};

export const DARK_THEME: SyntaxHighlightThemePalette = {
  bgPrimary: '#23232F',
  bgSecondary: GRAY_900,
  bgIndents: lightenOrDarkenColor(GRAY_900, 5, 'hex'), // 5% lighter
  bgHighlight: '#555572',

  border: GRAY_700,

  text01: WHITE,
  text02: GRAY_300,
  text03: lightenOrDarkenColor(GRAY_400, 2, 'hex'), // 2% lighter

  purple: '#c4a8ff',
  teal: '#10cca6',
  yellow: '#f5d44e',
  blue: '#00c9e3',
  raspberry: '#ff95ca',
  clementine: '#ff9e5e',

  greenBg: GREEN_900,
  greenFg: GREEN_100,

  redBg: RED_900,
  redFg: RED_100,
};

export const LIGHT_THEME: SyntaxHighlightThemePalette = {
  bgPrimary: '#fbfcfd',
  bgSecondary: GRAY_100,
  bgIndents: GRAY_200,
  bgHighlight: GRAY_300,

  border: GRAY_200,

  text01: GRAY_900,
  text02: GRAY_700,
  text03: GRAY_500,

  purple: '#5721cc',
  teal: '#00614e',
  yellow: '#6b5400',
  blue: '#005B8C',
  raspberry: '#ab0055',
  clementine: '#933b00',

  greenBg: GREEN_100,
  greenFg: GREEN_900,

  redBg: RED_100,
  redFg: RED_900,
};
